import { ErrorOutline } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import React from 'react';

function NotFound() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        backgroundColor: '#f5f5f5',
        color: '#333333',
        textAlign: 'center',
        px: 2,
        pt: 2,
        pb: 8,
      }}
    >
      <ErrorOutline sx={{ fontSize: 100, color: '#777777' }} />
      <Typography variant='h4' gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant='body1'>
        Sorry, the page you are looking for does not exist.
      </Typography>
    </Box>
  );
}

export default NotFound;
